<template lang="pug">
	div(class="kt-home-dashboard")
		div(class="kpi-row")
			div(v-for="kpi in d_kpis" :key="kpi.key" class="kpi-card")
				div(class="kpi-icon" :style="{ backgroundColor: kpi.iconBg }")
					fa-icon(:icon="kpi.icon")
				div(class="kpi-body")
					div(class="kpi-label") {{kpi.label}}
					div(class="kpi-value") {{kpi.value}}
					div(class="kpi-trend")
						fa-icon(icon="arrow-up")
						span {{kpi.trend}} from last Quarter

		div(v-if="c_checkPipelineBoard" class="pipeline-section" :class="{ collapsed: d_pipelineCollapsed }")
			div(class="pipeline-header")
				div(class="pipeline-title" @click="m_togglePipeline" title="Show or hide pipeline")
					span Pipeline Board
					fa-icon(icon="chevron-down" class="title-chevron")
				div(class="home-dashboard-reports" title="Reports")
					b-dropdown(right variant="outline-secondary" class="btn-menu staffing-export-dropdown")
						<span@click="m_closeChildWindow" style="background-color:white;" class="topright-close">&times;</span>
						template(v-slot:button-content)
							fa-icon(icon="file-export")
						kt-reports(:key="HomeDashboard" p_tableName="HomeDashboard" :p_cols="c_reportCols" 	:p_tableData="d_opportunities")
				div(class="pipeline-actions")
					b-dropdown(
						variant="none"
						size="sm"
						right
						boundary="window"
						:class="['btn-filter-dd', { active: c_filterActive }]"
					)
						template(v-slot:button-content)
							fa-icon(icon="filter")
							//span Filter
							span(v-if="c_filterActive" class="filter-count") {{c_filterCount}}
						div(class="pipeline-filter-menu" @click.stop)
							div(class="filter-field")
								label Search
								b-form-input(
									v-model="d_filterText"
									size="sm"
									placeholder="Name, company, stage..."
									debounce="200"
								)
							div(class="filter-field")
								div(class="filter-stages-hdr")
									label Stages
									span(class="btn btn-link btn-sm" @click="m_selectAllStages") All
									span(class="btn btn-link btn-sm" @click="m_clearStages") None
								b-form-checkbox-group(v-model="d_filterStages" stacked class="filter-stages")
									b-form-checkbox(
										v-for="col in d_pipelineColumns"
										:key="col.key"
										:value="col.key"
									) {{col.label}}
							div(class="filter-footer")
								b-button(size="sm" variant="none" class="btn-clear" @click="m_clearFilter") Clear
			div(v-show="!d_pipelineCollapsed" class="pipeline-board")
				div(v-if="c_visiblePipelineColumns.length === 0" class="pipeline-empty") No stages selected
				div(v-for="col in c_visiblePipelineColumns" :key="col.key" class="pipeline-column")
					div(class="column-header" :style="{ borderTopColor: col.color }")
						span {{col.label}}
						span(class="column-total") {{m_colTotal(col)}} ({{m_colCount(col)}})
					div(class="column-cards")
						draggable(
							:list="col.deals"
							group="pipeline"
							:animation="150"
							ghost-class="deal-ghost"
							drag-class="deal-drag"
							class="column-drag-list"
							@start="m_dragStart"
							@end="m_dragEnd"
							@change="m_changeStatus($event,col)"
						)
							div(
								v-for="deal in col.deals"
								:key="deal.id"
								v-show="m_dealMatches(deal)"
								class="deal-card"
								:class="{ won: col.key === 'awarded' }"
								@click="m_openOpportunity(deal)"
							)
								div(class="deal-title") {{deal.title}}
								div(class="deal-value") {{deal.value}}
								div(class="deal-company") {{deal.company}}
								div(class="deal-meta")
									span(v-if="deal.dueDate")
										| {{deal.stage}} • Due Date:
										b(class="deal-due-date")  {{deal.dueDate}}
									span(v-else) {{deal.stage}}
									span(v-if="deal.won") 🎉
								div(class="deal-avatars")
									div(
										v-for="(av, aix) in deal.avatars"
										:key="aix"
										class="deal-avatar"
										:style="{ backgroundColor: av.avatarColor }"
										:title="av.name"
									) {{av.initials}}
						div(v-if="m_colCount(col) === 0" class="column-empty") No matching deals
						// div(class="add-deal")
							// fa-icon(icon="plus")
							// span Add Deal

		div(v-if="c_checkPipelineCharts" class="pipeline-section" :class="{ collapsed: d_chartsCollapsed }")
			div(class="pipeline-header")
				div(class="pipeline-title" @click="m_toggleCharts" title="Show or hide pipeline charts")
					span Pipeline Charts
					fa-icon(icon="chevron-down" class="title-chevron")
			div(v-show="!d_chartsCollapsed" class="bottom-row")
				div(class="widget pipeline-chart-widget")
					div(class="widget-header")
						span Pipeline Value
						b-dropdown(
							variant="none"
							size="sm"
							right
							boundary="window"
							:class="['btn-filter-dd', { active: c_chartYearFilterActive }]"
						)
							template(v-slot:button-content)
								fa-icon(icon="filter")
								span(v-if="c_chartYearFilterActive" class="filter-count") {{c_chartYearFilterCount}}
							div(class="pipeline-filter-menu" @click.stop)
								div(class="filter-field")
									div(class="filter-stages-hdr")
										label Years
										span(class="btn btn-link btn-sm" @click="m_selectAllChartYears") All
										span(class="btn btn-link btn-sm" @click="m_clearChartYears") None
									b-form-checkbox-group(
										v-model="d_chartYears"
										stacked
										class="filter-stages"
										@change="m_updatePipelineChart"
									)
										b-form-checkbox(
											v-for="year in d_pipelineYears"
											:key="'yr-'+year"
											:value="year"
										) {{year}}
					div(class="chart-wrap")
						canvas(ref="pipelineChart")

				div(class="widget market-segment-widget")
					div(class="widget-header")
						span Market Segment
					div(class="donut-wrap")
						canvas(ref="marketSegmentChart")
					div(class="source-legend")
						div(v-for="seg in d_marketSegments" :key="seg.label" class="legend-item")
							span(class="legend-dot" :style="{ backgroundColor: seg.color }")
							span {{seg.label}}
							span(class="legend-pct") {{seg.pct}}%


 
		div(class="widget tasks-widget")
			div(class="task-dashboard d_flex")
				h2 Tasks:
			div(class="task-dashboard d_flex")
				div(class="d_flex task-card today" @click="m_goTasks()")
					span(class="task-label") Due Today:
					span(class="task-value") {{ d_tasks.dueToday||"None" }}	
				div(class="d_flex task-card this-week" @click="m_goTasks()")
					span(class="task-label") Due this week:
					span(class="task-value") {{ d_tasks.dueThisWeek||"None" }}	

</template>

<script>
import Chart from "chart.js";
import draggable from "vuedraggable";
import util,{fn_checkPageEnabled} from "@/utils/util.js";
import { fn_buildHomeDashboardData } from "@/utils/homeDashboardUtil.js";
import {refData} from "@/utils/ref-data.js";
import {fn_getPipelineData,fn_updateOpportunityColumn} from "@/utils/api.js";

export default {
	name: "kt-home-dashboard",
	components: {
		draggable,
	},
	created() {
		fn_getPipelineData().then(resp => {
            console.log('resp',resp);
		    this.d_tasks={...resp.tasks};
			let dashboardData = {opportunities:resp.opportunities,  
								 accounts:refData.accounts||[],
								 teamMembers:refData.teamMembers||[],
								 monthlyTotals:resp.monthlyTotals||[],
								 refData,
								 kpis:resp.kpis||{} 
								 };
			this.d_dashboard = fn_buildHomeDashboardData(dashboardData);
			console.log('this.d_dashboard',this.d_dashboard);
			this.d_filterStages = this.d_dashboard.pipelineColumns.map(col => col.key);
			this.d_kpis = [...this.d_dashboard.kpis];
			this.d_pipelineColumns = [...this.d_dashboard.pipelineColumns];
			this.d_marketSegments = [...this.d_dashboard.marketSegments];
			//this.d_tasks = this.d_dashboard.tasks;
			this.d_pipelineChartData = [...this.d_dashboard.pipelineChartData];
			this.d_opportunities = [...this.d_dashboard.opportunities];
			this.d_pipelineYears = this.m_uniqueYearNumbers(resp.monthlyTotals);
			this.d_chartYears = [...this.c_defaultChartYears];
			this.$nextTick(() => {
				this.m_renderMarketSegmentChart();
				this.m_updatePipelineChart();
			});
		    
	
		});
		
	},	   
	mounted() {},
	beforeDestroy() {
		if (this.d_pipelineChart) {
			this.d_pipelineChart.destroy();
			this.d_pipelineChart = null;
			}
		if (this.d_marketSegmentChart) {
		   this.d_marketSegmentChart.destroy();
		   this.d_marketSegmentChart = null;
		   }
	},
	data() {
		return {
			d_chartPeriod: "thisMonth",
			d_chartPeriods: [
				{ text: "This Month", value: "thisMonth" },
				{ text: "Last Month", value: "lastMonth" },
				{ text: "This Quarter", value: "thisQuarter" },
				{ text: "This Year", value: "thisYear" },
				{ text: "Next Year", value: "nextYear" },
			],
			d_pipelineChart: null,
			d_marketSegmentChart: null,
			d_dragging: false,
			d_filterText: "",
			d_filterStages:null,
			d_kpis:[] ,
			d_pipelineColumns:[],
			d_marketSegments:[],
			d_tasks: {},
			d_pipelineChartData: [],
			d_opportunities: [],
			d_taskRecMode: null,
			d_taskPrntKey: null,
			d_taskId: null,
			d_taskRecData: null,
			d_dashboard:{opportunities:[],
			             accounts:[],
						 teamMembers:[],
			             monthlyTotals:[],
						 activities:[],
						 refData:[],
						 kpis:[],
						 },
			d_allOpportnities:[],
			d_pipeliineMonthlyTotals:[],
			d_pipelineYears:[],
			d_chartYears:[],
			d_pipelineCollapsed: false,
			d_chartsCollapsed: false,
						 
		};
	},
    watch: {},
	computed: {
		c_visiblePipelineColumns() {
			const stages = this.d_filterStages || [];
			return this.d_pipelineColumns.filter(col => stages.includes(col.key));
		},
		c_filterActive() {
			const allStages = this.d_pipelineColumns?.length;
			return !!(this.d_filterText || "").trim() || this.d_filterStages?.length !== allStages;
		},
		c_filterCount() {
			return (this.d_filterStages || []).length;
		},
		c_checkPipelineBoard(){return fn_checkPageEnabled('Home','Pipeline Board');},
		c_checkPipelineCharts(){return fn_checkPageEnabled('Home','Pipeline Charts');},
		c_defaultChartYears() {
			const currentYear = new Date().getFullYear();
			const defaults = (this.d_pipelineYears || []).filter(y => Number(y) === currentYear || Number(y) === currentYear - 1);
			return defaults.length ? defaults : (this.d_pipelineYears || []).slice(0, 2);
		},
		c_chartYearFilterActive() {
			const selected = [...(this.d_chartYears || [])].map(Number).sort((a, b) => a - b);
			const defaults = [...this.c_defaultChartYears].map(Number).sort((a, b) => a - b);
			if (selected.length !== defaults.length) return true;
			return selected.some((y, i) => y !== defaults[i]);
		},
		c_chartYearFilterCount() {
			return (this.d_chartYears || []).length;
		},
		c_reportCols(){
			return [{field:"recordType",title:"Type",visible:true,datatype:"text"},
			{field:"project",title:"Project",visible:true,datatype:"text"},
			{field:"opportunity",title:"Opportunity",visible:true,datatype:"text"},
			{field:"roleName",title:"Title",visible:true,datatype:"text"},
			{field:"teamMemberName",title:"Name",visible:true,datatype:"text"},
			{field:"startDate",title:"Start Date",visible:true,datatype:"date"},
			{field:"endDate",title:"End Date",visible:true,datatype:"date"},
			{field:"timePercent",title:"Time Allocation",visible:true,datatype:"num"},
			];
		}
	},
	methods: {
		m_resizeDashboardCharts() {
			this.$nextTick(() => {
				if (this.d_pipelineChart) this.d_pipelineChart.resize();
				if (this.d_marketSegmentChart) this.d_marketSegmentChart.resize();
			});
		},
		m_togglePipeline() {
			this.d_pipelineCollapsed = !this.d_pipelineCollapsed;
			this.m_resizeDashboardCharts();
		},
		m_toggleCharts() {
			this.d_chartsCollapsed = !this.d_chartsCollapsed;
			this.m_resizeDashboardCharts();
		},
		m_uniqueYearNumbers(monthlyTotals) {
			const years = (monthlyTotals || [])
				.map(y => y && y.yearNumber)
				.filter(y => y != null && y !== "");
			return years.filter((y, i) => years.findIndex(v => String(v) === String(y)) === i)
				.sort((a, b) => Number(b) - Number(a));
		},
		m_selectAllChartYears() {
			this.d_chartYears = [...this.d_pipelineYears];
			this.m_updatePipelineChart();
		},
		m_clearChartYears() {
			this.d_chartYears = [];
			this.m_updatePipelineChart();
		},
		/** Disable globally-registered label plugins (Dashboard imports them). */
		m_chartPluginOptions() {
			return {
				// chartjs-plugin-labels (slice/bar text)
				labels: false,
				// chartjs-plugin-datalabels
				datalabels: {
					display: false,
				},
			};
		},
		m_fmtCurrency(val) {
			if (val >= 1000000) return "$" + (val / 1000000).toFixed(2) + "M";
			if (val >= 1000) return "$" + Math.round(val / 1000).toLocaleString() + "K";
			return "$" + Math.round(val || 0).toLocaleString();
		},
		m_fmtAxisCurrency(val) {
			if (val == null || isNaN(val)) return "";
			if (val === 0) return "$0";
			if (val >= 1000000) {
				const m = val / 1000000;
				return "$" + (Math.abs(m - Math.round(m)) < 0.05 ? Math.round(m) : m.toFixed(1)) + "M";
			}
			if (val >= 1000) return "$" + Math.round(val / 1000) + "K";
			return "$" + Math.round(val);
		},
		m_dealMatches(deal) {
			const q = (this.d_filterText || "").trim().toLowerCase();
			if (!q) return true;
			return [deal.title, deal.company, deal.stage, deal.value, deal.opportunityNo]
				.some(v => String(v || "").toLowerCase().includes(q));
		},
		m_colCount(col) {
			return (col.deals || []).filter(d => this.m_dealMatches(d)).length;
		},
		m_colTotal(col) {
			const totalVal = (col.deals || [])
				.filter(d => this.m_dealMatches(d))
				.reduce((sum, d) => sum + (d.valueRaw || 0), 0);
			return this.m_fmtCurrency(totalVal);
		},
		m_clearFilter() {
			this.d_filterText = "";
			this.d_filterStages = this.d_pipelineColumns.map(col => col.key);
		},
		m_selectAllStages() {
			this.d_filterStages = this.d_pipelineColumns.map(col => col.key);
		},
		m_clearStages() {
			this.d_filterStages = [];
		},
		m_openOpportunity(deal) {
			if (this.d_dragging || !deal.opportunityNo) return;
			this.$router.push({ path: util.fn_hrefVwRec("oppr", deal.opportunityNo) });
		},
		m_openTask(task) {
			if (!task || !task.prntType) return;
			const taskId = Number(task.id);
			if (!taskId) return;

			const taskData = task.taskData ? { ...task.taskData } : null;
			if (taskData) {
				const idKey = {
					oppr: "opportunityTaskId",
					proj: "projectTaskId",
					acct: "accountTaskId",
					cal: "calendarTaskId",
				}[task.prntType];
				if (idKey && !taskData[idKey]) taskData[idKey] = taskId;
				if (!taskData.id) taskData.id = taskId;
			}

			this.d_taskPrntKey = task.prntType;
			this.d_taskId = taskId;
			this.d_taskRecData = taskData;
			this.d_taskRecMode = "edit";
		},
		m_closeTask() {
			this.d_taskRecMode = null;
			this.d_taskPrntKey = null;
			this.d_taskId = null;
			this.d_taskRecData = null;
		},
		m_viewAllTasks() {
			this.$router.push({ path: "#cal-activities" });
		},
		m_dragStart(e) {
			
			this.d_dragging = true;
		},
		m_dragEnd(e) {
		    console.log('draggable event data',e);
			this.d_pipelineColumns.forEach(col => {
				(col.deals || []).forEach(deal => {
					deal.stage = col.label;
					deal.won = col.key === "awarded";
				});
			});
			this.m_refreshColumnTotals();
			// Delay clearing so click after drag is ignored
			setTimeout(() => { this.d_dragging = false; }, 50);
		},
		m_refreshColumnTotals() {
			this.d_pipelineColumns.forEach(col => {
				const totalVal = (col.deals || []).reduce((sum, d) => sum + (d.valueRaw || 0), 0);
				col.total = this.m_fmtCurrency(totalVal);
				col.count = (col.deals || []).length;
			});
		},
      m_updatePipelineChart() {
         const colors = ["#007bff", "#28a745", "#ffc107", "#dc3545", "#6f42c1"];
         const selected = this.d_chartYears || [];
         const rows = Array.isArray(this.d_pipelineChartData) ? this.d_pipelineChartData : [];
         const source = rows
            .filter(mt => mt && selected.some(y => String(y) === String(mt.yearNumber)))
            .sort((a, b) => Number(b.yearNumber) - Number(a.yearNumber));

         const chartDatasets = source.map((mt) => {
            const year = mt.yearNumber;
            const colorIx = Math.max(0, this.d_pipelineYears.findIndex(y => String(y) === String(year)));
            return {
               label: String(year),
               borderColor: colors[colorIx % colors.length],
               backgroundColor: colors[colorIx % colors.length],
               fill: false,
               lineTension: 0.2,
               data: (mt.months || []).map(m => m.totalValue)
            };
         });
      this.d_pipelineChartData.labels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      this.d_pipelineChartData.datasets = chartDatasets;
	  const allValues = chartDatasets.flatMap(d => d.data || []);
	  this.m_applyPipelineYScale(allValues);
	  if (this.d_pipelineChart) {
	        this.d_pipelineChart.data.labels = this.d_pipelineChartData.labels;
	        this.d_pipelineChart.data.datasets = chartDatasets;
	        this.d_pipelineChart.update();
	  } else {
	        this.$nextTick(() => this.m_renderPipelineChart());
	  }
      },	   
		m_applyPipelineYScale(dataPoints) {
			if (!this.d_pipelineChart) return;
			const maxVal = Math.max(0, ...(dataPoints || [0]));
			const ticks = this.d_pipelineChart.options.scales.yAxes[0].ticks;
			ticks.beginAtZero = true;
			ticks.min = 0;
			ticks.suggestedMax = maxVal > 0 ? maxVal * 1.1 : 1000000;
		},
    m_renderPipelineChart() {
    const ctx = this.$refs.pipelineChart;
    if (!ctx) return;

    const chartData = this.d_pipelineChartData;
    const datasets = (chartData && chartData.datasets) || [];
    const labels = (chartData && chartData.labels) || ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const allValues = datasets.flatMap(ds => ds.data || []);
    const maxVal = allValues.length ? Math.max(0, ...allValues) : 0;

    if (this.d_pipelineChart) {
        this.d_pipelineChart.destroy();
        this.d_pipelineChart = null;
    }

    this.d_pipelineChart = new Chart(ctx, {
        type: "line",
        data: {
            labels: labels,
            datasets: datasets,   // Multi line
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            legend: { display: true },   // show multiple line labels
            plugins: this.m_chartPluginOptions(),
            tooltips: {
                callbacks: {
                    label: (item) => this.m_fmtCurrency(item.yLabel),
                },
            },
            scales: {
                xAxes: [{
                    gridLines: { display: false },
                    ticks: { fontColor: "#6c757d", fontSize: 11 },
                }],
                yAxes: [{
                    gridLines: { color: "#f0f0f0", zeroLineColor: "#dee2e6" },
                    ticks: {
                        beginAtZero: true,
                        min: 0,
                        suggestedMax: maxVal > 0 ? maxVal * 1.1 : 1000000,
                        fontColor: "#6c757d",
                        fontSize: 11,
                        callback: (val) => this.m_fmtAxisCurrency(val),
                        maxTicksLimit: 6,
                    },
                }],
            },
        },
    });
},
		m_renderMarketSegmentChart() {
			const ctx = this.$refs.marketSegmentChart;
			if (!ctx) return;
			if (this.d_marketSegmentChart) {
				this.d_marketSegmentChart.destroy();
				this.d_marketSegmentChart = null;
			}

			this.d_marketSegmentChart = new Chart(ctx, {
				type: "doughnut",
				data: {
					labels: this.d_marketSegments.map((s) => s.label),
					datasets: [{
						data: this.d_marketSegments.map((s) => s.pct),
						backgroundColor: this.d_marketSegments.map((s) => s.color),
						borderWidth: 2,
						borderColor: "#fff",
					}],
				},
				options: {
					responsive: true,
					maintainAspectRatio: false,
					cutoutPercentage: 65,
					legend: { display: false },
					plugins: this.m_chartPluginOptions(),
					tooltips: {
						callbacks: {
							label: (item, data) => {
								const label = data.labels[item.index];
								return label + ": " + data.datasets[0].data[item.index] + "%";
							},
						},
					},
				},
			});
		},
		m_changeStatus(e,col){
			if (e.added) {
			     console.log('e',e);
				 console.log('col',col);
				//const {opportunityNo,stage} = e.added.element;
				const opportunityId = e.added.element.id;
				const stage = col.label;
				console.log('opportunityId',opportunityId);
				console.log('stage',stage);
				const opportunityTypeRec = refData.opportunityTypes.find(ot => ot.name == stage);
				console.log('opportunityTypeRec',opportunityTypeRec);
				const opportunityTypeId = opportunityTypeRec.id;
				console.log(`In m_changeStatus opportunityId ${opportunityId} opportunityTypeId ${opportunityTypeId}`);
				fn_updateOpportunityColumn({opportunityId, columnName:'opportunityTypeId',newValueNumber:opportunityTypeId});
			}
		},
		m_goTasks() {this.$router.push({ path: "#cal-activities" });},
	},
};
</script>

<style scoped lang="less">
.kt-home-dashboard {
	width: 100%;
	padding1: 0.5em 0.75em;
	text-align: left;

	.kpi-row {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 0.75em;
		margin-bottom: 1em;

		@media (max-width: 992px) {
			grid-template-columns: repeat(2, 1fr);
		}
		@media (max-width: 576px) {
			grid-template-columns: 1fr;
		}
	}

	.kpi-card {
		display: flex;
		align-items: flex-start;
		gap: 0.75em;
		background: #fff;
		border: 1px solid #e9ecef;
		border-radius: 0.5em;
		padding: 1em;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);

		.kpi-icon {
			width: 40px;
			height: 40px;
			border-radius: 0.5em;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			color: #fff;
			font-size: 1em;
		}

		.kpi-label {
			font-size: 0.8em;
			color: #6c757d;
			margin-bottom: 0.25em;
		}

		.kpi-value {
			font-size: 1.35em;
			font-weight: 700;
			color: #212529;
			line-height: 1.2;
		}

		.kpi-trend {
			font-size: 0.75em;
			color: #27ae60;
			margin-top: 0.35em;

			svg {
				margin-right: 0.25em;
			}
		}
	}

	.pipeline-section {
		background: #fff;
		border: 1px solid #e9ecef;
		border-radius: 0.5em;
		padding: 0.75em 1em 1em;
		margin-bottom: 1em;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
		overflow: visible;

		&.collapsed {
			padding-bottom: 0.75em;

			.pipeline-header {
				margin-bottom: 0;
			}

			.title-chevron {
				transform: rotate(-90deg);
			}
		}
	}

	.pipeline-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0.75em;
		flex-wrap: wrap;
		gap: 0.5em;
	}

	.pipeline-title {
		font-size: 1.1em;
		font-weight: 600;
		color: #212529;
		cursor: pointer;
		user-select: none;
		display: flex;
		align-items: center;

		.title-chevron {
			font-size: 0.65em;
			margin-left: 0.4em;
			color: #6c757d;
			transition: transform 0.2s ease;
		}
	}

	.pipeline-actions {
		display: flex;
		gap: 0.5em;
		align-items: center;

		.btn-filter-dd {
			.dropdown-toggle {
				display: inline-flex;
				align-items: center;
				gap: 0.35em;
				font-size: 0.85em;
				border:none;
			}

			&.active .dropdown-toggle {
				border-color: #4fa4ff;
				color: #4fa4ff;
			}

			/deep/ .dropdown-menu {
				z-index: 3000;
			}

			.filter-count {
				background: #4fa4ff;
				color: #fff;
				border-radius: 999px;
				font-size: 0.7em;
				min-width: 1.2em;
				padding: 0 0.35em;
				line-height: 1.4;
				text-align: center;
			}
		}
	}

	.pipeline-filter-menu {
		min-width: 240px;
		padding: 0.6em 0.75em;
		text-align: left;

		.filter-field {
			margin-bottom: 0.75em;

			label {
				display: block;
				font-size: 0.75em;
				font-weight: 600;
				color: #6c757d;
				margin-bottom: 0.25em;
			}
		}

		.filter-stages-hdr {
			display: flex;
			align-items: center;
			gap: 0.25em;
			margin-bottom: 0.25em;

			label {
				margin: 0;
				margin-right: auto;
			}

			.btn-link {
				padding: 0;
				font-size: 0.75em;
			}
		}

		.filter-stages {
			max-height: 180px;
			overflow-y: auto;
			font-size: 0.85em;
		}

		.filter-footer {
			display: flex;
			justify-content: flex-end;
			border-top: 1px solid #e9ecef;
			padding-top: 0.5em;
		}
	}

	.pipeline-empty,
	.column-empty {
		padding: 0.75em 0.4em;
		text-align: center;
		font-size: 0.78em;
		color: #868e96;
	}

	.pipeline-board {
		display: flex;
		gap: 0.6em;
		overflow-x: auto;
		padding-bottom: 0.5em;

		&::-webkit-scrollbar {
			height: 0.4em;
		}
		&::-webkit-scrollbar-thumb {
			background-color: #ced4da;
			border-radius: 0.4em;
		}
	}

	.pipeline-column {
		flex: 0 0 210px;
		min-width: 210px;
		background: #f8f9fa;
		border-radius: 0.4em;
		display: flex;
		flex-direction: column;
	}

	.column-header {
		padding: 0.5em 0.6em;
		border-top: 3px solid;
		font-size: 0.85em;
		font-weight: 600;
		display: flex;
		flex-direction: column;
		gap: 0.15em;

		.column-total {
			font-size: 0.8em;
			font-weight: 400;
			color: #6c757d;
		}
	}

	.column-cards {
		padding: 0 0.4em 0.4em;
		flex: 1;
		overflow-y: auto;
		max-height: 280px;
		display: flex;
		flex-direction: column;
	}

	.column-drag-list {
		min-height: 40px;
		flex: 1;
	}

	.deal-card {
		background: #fff;
		border: 1px solid #e9ecef;
		border-radius: 0.35em;
		padding: 0.55em 0.6em;
		margin-bottom: 0.5em;
		position: relative;
		cursor: grab;
		transition: box-shadow 0.15s;

		&:hover {
			box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
		}

		&:active {
			cursor: grabbing;
		}

		&.won {
			border-color: #a9dfbf;
		}

		&.deal-ghost {
			opacity: 0.4;
			border: 1px dashed #4fa4ff;
		}

		&.deal-drag {
			opacity: 0.95;
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
			cursor: grabbing;
		}

		.deal-title {
			font-size: 0.82em;
			font-weight: 600;
			color: #212529;
			padding-right: 1.8em;
			line-height: 1.3;
		}

		.deal-value {
			font-size: 0.78em;
			color: #495057;
			margin-top: 0.2em;
		}

		.deal-company {
			font-size: 0.72em;
			color: #868e96;
			margin-top: 0.15em;
		}

		.deal-meta {
			font-size: 0.68em;
			color: #adb5bd;
			margin-top: 0.35em;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.deal-due-date {
				color: #000;
				font-weight: 700;
			}
		}

		.deal-avatars {
			position: absolute;
			top: 0.5em;
			right: 0.5em;
			display: flex;
			flex-direction: row-reverse;
		}

		.deal-avatar {
			width: 24px;
			height: 24px;
			border-radius: 50%;
			color: #fff;
			font-size: 0.55em;
			font-weight: 700;
			display: flex;
			align-items: center;
			justify-content: center;
			border: 1.5px solid #fff;
			margin-left: -6px;

			&:last-child {
				margin-left: 0;
			}
		}
	}

	.add-deal {
		text-align: center;
		padding: 0.4em;
		font-size: 0.78em;
		color: #4fa4ff;
		cursor: pointer;

		svg {
			margin-right: 0.25em;
		}

		&:hover {
			text-decoration: underline;
		}
	}

	.bottom-row {
		display: grid;
		grid-template-columns: 2fr 1.2fr;
		gap: 0.75em;
		margin-bottom: 0;

		@media (max-width: 768px) {
			grid-template-columns: 1fr;
		}
	}

	.tasks-widget {
		width: 100%;
	}

	.widget {
		background: #fff;
		border: 1px solid #e9ecef;
		border-radius: 0.5em;
		padding: 0.75em 1em;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
		overflow: visible;
	}

	.widget-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-weight: 600;
		font-size: 0.95em;
		margin-bottom: 0.5em;
		color: #212529;

		.btn-filter-dd {
			.dropdown-toggle {
				display: inline-flex;
				align-items: center;
				gap: 0.35em;
				font-size: 0.85em;
				border: none;
				padding: 0.15em 0.4em;
			}

			&.active .dropdown-toggle {
				color: #4fa4ff;
			}

			/deep/ .dropdown-menu {
				z-index: 3000;
			}

			.filter-count {
				background: #4fa4ff;
				color: #fff;
				border-radius: 999px;
				font-size: 0.7em;
				min-width: 1.2em;
				padding: 0 0.35em;
				line-height: 1.4;
				text-align: center;
				font-weight: 600;
			}
		}

		.period-select {
			width: auto;
			font-size: 0.8em;
			font-weight: 400;
			border1: 1px solid #dee2e6;
			border-radius1: 0.25em;
            border: none;
		}

		.view-all {
			font-size: 0.85em;
			font-weight: 400;
			color: #4fa4ff;
			cursor: pointer;

			&:hover {
				text-decoration: underline;
			}
		}
	}

	.chart-wrap {
		height: 300px;
		position: relative;
	}

	.donut-wrap {
		height: 140px;
		position: relative;
		margin-bottom: 0.5em;
	}

	.source-legend {
		.legend-item {
			display: flex;
			align-items: center;
			gap: 0.4em;
			font-size: 0.78em;
			padding: 0.2em 0;
			color: #495057;

			.legend-dot {
				width: 10px;
				height: 10px;
				border-radius: 50%;
				flex-shrink: 0;
			}

			.legend-pct {
				margin-left: auto;
				font-weight: 600;
			}
		}
	}

	.task-list {
		max-height: 220px;
		overflow-y: auto;
	}

	.task-empty {
		padding: 1em 0;
		text-align: center;
		font-size: 0.85em;
		color: #868e96;
	}

	.task-item {
		display: flex;
		align-items: center;
		gap: 0.6em;
		padding: 0.45em 0;
		border-bottom: 1px solid #f0f0f0;
		font-size: 0.82em;
		cursor: pointer;
		border-radius: 0.25em;
		transition: background-color 0.12s;

		&:last-child {
			border-bottom: none;
		}

		&:hover {
			background-color: #f8f9fa;
		}
	}

	.task-check {
		width: 18px;
		height: 18px;
		border: 2px solid #dee2e6;
		border-radius: 50%;
		flex-shrink: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 0.65em;
		color: #fff;

		&.done {
			background-color: #4fa4ff;
			border-color: #4fa4ff;
		}
	}

	.task-text {
		flex: 1;
		color: #212529;
		line-height: 1.3;
	}

	.task-date {
		font-size: 0.85em;
		color: #6c757d;
		flex-shrink: 0;

		&.overdue {
			color: #e74c3c;
		}
	}
}
/* Remove default BootstrapVue dropdown styling */
.export-trigger + .dropdown-menu {
  border: none !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08) !important; /* light shadow */
  padding: 6px 0 !important;
  background: white !important;
  min-width: 200px !important;
}

/* Remove extra padding Bootstrap adds */
::v-deep .export-menu {
  border: none !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08) !important;
  padding: 6px 0 !important;
  background: #fff !important;
  min-width: 200px;
}
::v-deep .dropdown-menu {
  border: none !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08) !important; /* light shadow */
  padding: 6px 0 !important;
  background: white !important;
  min-width: 200px !important;
}
btn-clear{
	border:none;
	width:20px;
	height:20px;
}
button:focus {
  border: none;
  outline: none;
  box-shadow: none;
}
.task-dashboard1 {
  display: flex;
  gap: 16px;
}

.task-card1 {
  flex: 1;
  padding: 16px;
  border-radius: 10px;
  background: #f8f9fa;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  text-align: center;
}

.task-count {
  font-size: 32px;
  font-weight: 700;
  color: #007bff;
}
.task-dashboard {
  display: flex;
  flex-direction1: column;
  gap: 12px;
  margin-top1: 12px;
}

.task-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding1: 14px 18px;
  background1: #ffffff;
  background: #e9f3ff; /* very light blue */
  border-radius1: 10px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  cursor: pointer;
  transition: transform 0.1s ease, box-shadow 0.15s ease;
  width:15%
}

.task-card:hover {
  background: #dcecff;
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0,0,0,0.12);
  
}

.task-label {
  font-size: 14px;
  color1: #6c757d;
   color: #2f3b52; /* darker muted text */
}

.task-value {
  font-size: 20px;
  font-weight: 700;
  color1: #007bff;
  color: #1a3d7c; /* darker blue */
}
.task-card.today {
  background: #fff3b0;        /* stronger yellow */
  border1: 1px solid #e6c96a;
  border:none;
  color: #3f320a;
}
.task-card.this-week {
  background: #fff9d6;        /* softer variant */
  border1: 1px solid #e8d9a3;
  border:none;
  color: #4a3f1a;
}
h2 {
  font-size: 1.3rem;   /* slightly smaller */
  font-weight: 600;
}
.topright-close {
  color: red;
  font-size: 20px;
}
.home-dashboard-reports .topright-close:hover {color: green;}
</style>
